






































































































































































import Vue from 'vue';

import { EmployeeType } from '@/models';
import { EmployeeFilterParams } from '@/store/employee';
import HRDepartmentPicker from './hr/HRDepartmentPicker.vue';
import EmployeePicker from './EmployeePicker.vue';

export default Vue.extend({
  components: { HRDepartmentPicker, EmployeePicker },
  name: 'EmployeeSearchFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as EmployeeFilterParams,

      employeeTypeList: [
        {
          value: EmployeeType.Hourly,
          display_name: 'Hourly'
        },
        {
          value: EmployeeType.Salary,
          display_name: 'Salary'
        }
      ],

      isActiveTypeList: [
        {
          value: 'true',
          display_name: 'Active'
        },
        {
          value: 'false',
          display_name: 'InActive'
        }
      ]
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: EmployeeFilterParams) {
      if (params.type != null && !isNaN(params.type)) {
        this.filterParams.type = Number(params.type);
      }

      if (params.supervisor && !isNaN(params.supervisor)) {
        this.filterParams.supervisor = Number(params.supervisor);
      }

      if (params.hr_department && !isNaN(params.hr_department)) {
        this.filterParams.hr_department = Number(params.hr_department);
      }

      this.filterParams.is_active = params.is_active;

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
